import * as Yup from "yup";

export function getAuthInitialValues() {
  return {
    email: "",
  };
}

const VALIDATION_SCHEMA = (locale) => Yup.object().shape({
    email: Yup.string()
    .email(locale('emailInvalid')).required(locale('emailMandatory'))
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int){1}$/,"Please enter a valid email."),
});

export { VALIDATION_SCHEMA };
